import React from "react";
import { useOnboarding } from "../../contexts/OnboardingContext";

// One segment per step, filled as far as the current one — the funnel's
// step header, so the two flows read as one product.
const OnboardingProgress = () => {
  const { currentStep, totalSteps } = useOnboarding();
  return (
    <>
      <div
        className="ob-segments"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-valuenow={currentStep}
        aria-label={`Step ${currentStep} of ${totalSteps}`}
      >
        {Array.from({ length: totalSteps }, (_, i) => (
          <div key={i} className={`ob-segment${i < currentStep ? " is-filled" : ""}`} />
        ))}
      </div>
      <span className="ob-step-count" aria-hidden="true">
        {currentStep}/{totalSteps}
      </span>
    </>
  );
};

export default OnboardingProgress;
